package com.anjuros.website.templates.selection.components.contactform

import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.components.language.ResKeyType
import com.anjuros.website.templates.selection.util.Res
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px


data class ContactFormInfo(
    val index:Int=-1,
    val type: ContactFormDetailsType = ContactFormDetailsType.INPUT,
    val autoFill: ContactAutoFill = ContactAutoFill.TEXT,
    val placeholderText: ResKeyType,
    val labelText: ResKeyType,
    val nameText: String,
    val required: Boolean,
    val inputText:String="",
    val errorMessage:ResKeyType?=null,
    val height: CSSSizeValue<CSSUnit.px>?=null,
    val optionList:List<ResKeyType> = emptyList(),
    val linkedOptionList:Map<ResKeyType, List<ResKeyType>> = emptyMap(),
    val validations: List<(String) -> ValidationResult> = emptyList()
){
    fun validate(): List<ValidationResult> =
        validations.map { validator ->
            validator(inputText)
        }
}

data class ValidationResult(
    val isValid: Boolean,
    val message: ResKey? = null
)

val requiredValidator: (String) -> ValidationResult = {

    ValidationResult(
        isValid = it.isNotBlank(),
        message =  ResKey.CONTACT_FORM_REQUIRED
    )
}

val emailValidator: (String) -> ValidationResult = {
    ValidationResult(
        isValid = it.matches(Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)+$")),
        message = ResKey.CONTACT_FORM_EMAIL_VALID
    )
}

val phoneValidator: (String) -> ValidationResult = {
    ValidationResult(
        isValid = it.matches(Regex("^(\\+?[0-9]{10,15})$")),
        message = ResKey.CONTACT_FORM_PHONE_VALID
    )
}

val NAME_CONTACT_FORM = ContactFormInfo(
    type = ContactFormDetailsType.INPUT,
    placeholderText = ResKey.CONTACT_NAME,
    labelText = ResKey.CONTACT_NAME_LABEL,
    nameText = "Name",
    required = true,
    validations = listOf(
        requiredValidator
    )
)
val PHONE_NUMBER_CONTACT_FORM = ContactFormInfo(
    type = ContactFormDetailsType.INPUT,
    autoFill = ContactAutoFill.PHONE,
    placeholderText = ResKey.CONTACT_PHONE,
    labelText = ResKey.CONTACT_PHONE_LABEL,
    nameText = "Phone",
    required = true,
    validations = listOf(
        requiredValidator,
        phoneValidator
    )
)
val EMAIL_CONTACT_FORM = ContactFormInfo(
    type = ContactFormDetailsType.INPUT,
    autoFill = ContactAutoFill.EMAIL,
    placeholderText = ResKey.CONTACT_EMAIL,
    labelText = ResKey.CONTACT_EMAIL_LABEL,
    nameText = "Email",
    required = true,
    validations = listOf(
        requiredValidator,
        emailValidator
    )
)

val MESSAGE_CONTACT_FORM = ContactFormInfo(
    type = ContactFormDetailsType.TEXT_AREA,
    placeholderText = ResKey.CONTACT_MESSAGE,
    labelText = ResKey.CONTACT_MESSAGE_LABEL,
    nameText = "Message",
    required = true,
    height = 150.px,
    validations = listOf(
        requiredValidator
    )
)

val NOTE_CONTACT_FORM = ContactFormInfo(
    type = ContactFormDetailsType.TEXT_AREA,
    placeholderText = ResKey.CONTACT_NOTE,
    labelText = ResKey.CONTACT_NOTE_LABEL,
    nameText = "Note",
    required = false,
    height = 150.px,
    validations = emptyList()
)

val DROPDOWN_CONTACT_FORM = ContactFormInfo(
    type = ContactFormDetailsType.DROP_DOWN,
    placeholderText = ResKey.CONTACT_MESSAGE,
    labelText = ResKey.CONTACT_MESSAGE_LABEL,
    nameText = "",
    required = true,
    validations = listOf(
        requiredValidator
    )
)

enum class ContactFormDetailsType(){
    INPUT, TEXT_AREA,DROP_DOWN,DROP_DOWN_LINKED, DATE_PICKER, RADIO_BUTTON, TICK_BOX
}

enum class ContactAutoFill(){
    TEXT,EMAIL,PHONE
}

